export default __webpack_public_path__ + "static/media/success.f1a11dd4.svg";